import { render, staticRenderFns } from "./BulkDivisionUpdate.vue?vue&type=template&id=55cae0c8&"
import script from "./BulkDivisionUpdate.vue?vue&type=script&lang=js&"
export * from "./BulkDivisionUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
